/**
 * Request header our own client apps send on every API request, naming which
 * app sent it. The origin guard requires it of a write that carries no browser
 * origin headers; `OriginVerdict` and `classifyOrigin` in
 * `security/originGuard.ts` explain why, and why it's only ever a reason to
 * refuse. The technique:
 * https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html#employing-custom-request-headers-for-ajaxapi
 *
 * No `X-` prefix: https://www.rfc-editor.org/rfc/rfc6648
 */
export const OKTHX_CLIENT_HEADER = "Okthx-Client";

/**
 * One value per client app rather than a broad category, so another web
 * property or native platform adds its own value and the header doubles as an
 * analytics dimension.
 */
export type ClientName = "web-app" | "ios";
